import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAppConfig } from '../app/model/app-config.model';
import { DIMBO_CONSTANT } from './utils/constant';


@Injectable()
export class AppConfig {
    public apiUrl: string;
    public apiPath: string;
    public mpsaFlag: string;
    public allowedReferrers: string[];
    public issuerURL: string;
    public clientID: string;
    public redirectURI: string;
    public logoutURL: string;
    public scopeVar: string;
    public idpTokenEndpoint: string;
    public requireHttps: boolean;

    constructor(private http: HttpClient) {}

    load(url: string): Promise<any> {
        const promise = this.http.get(url)
        .toPromise()
        .then(data => {
          Object.assign(this, data);
          return data;
        });

      return promise;
    }

    getAppConfig() {
        // Return all config properties as an object
        return {
            apiUrl: this.apiUrl,
            apiPath: this.apiPath,
            mpsaFlag: this.mpsaFlag,
            allowedReferrers: this.allowedReferrers,
            issuerURL: this.issuerURL,
            clientID: this.clientID,
            redirectURI: this.redirectURI,
            logoutURL: this.logoutURL,
            scopeVar: this.scopeVar,
            idpTokenEndpoint: this.idpTokenEndpoint,
            requireHttps: this.requireHttps
        };
    }
}